import { DependencyList, useRef, useEffect } from "react";

export const useUpdateEffect = (effect: () => void, deps: DependencyList) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (isMounted.current) {
        effect();
      } else {
        isMounted.current = true;
      }
    } else {
      effect();
    }
  }, deps);


};
